import RichTextEditor from "../RichTextEditor";

export interface RichTextInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  label: string;
  onChange?: (value: string) => void;
  errorText?: string;
}

export const RichTextInput = ({
  id,
  name,
  label,
  onChange,
  required,
  errorText,
  value,
  className,
  ...restProps
}: RichTextInputProps) => {
  return (
    <div className="mb-4">
      {label && (
        <div className="mb-2 block">
          <label
            htmlFor={name}
            className="block mb-2 text-sm font-semibold text-gray-900 dark:text-white"
          >
            {label} {required ? <span className="text-red-500">*</span> : ""}
          </label>
        </div>
      )}
      <RichTextEditor
        className={className}
        value={value as string}
        onChange={onChange}
        placeholder={restProps.placeholder}
        readOnly={restProps.readOnly}
      />
      {errorText && <p className="text-xs text-red-500 mt-1">{errorText}</p>}
    </div>
  );
};
